import React from 'react';
import Grid from "@mui/material/Grid";
import { startOfWeekMon, endOfWeekSun, tomorrow, shiftWeek, shiftHours, undoDateFormat, dateFormat, textfieldDateFormat } from "../../utils/dateFunctions";
import { Locations } from "../../utils/constants/locations";
import { getOysterGrades, gradeSort } from "../../definitions/oysters";
import DateSelector from "../../shared/DateSelectorMultiWeek";
import WarehouseSelector from "../../components/WarehouseSelector";
import PurchaseOrders from '../Procurement/Tables/PurchaseOrders';
import POSummaryPoints from '../Procurement/Stats/POSummaryPoints';
import SelectFarmWarehouse from 'app/components/SelectFarmWarehouse';
import { getAPIDataParamsReturn, getAPIDataReturn } from "../../utils/apiFunction";
import { KEYWAREHOUSESTRINGS } from '../../utils/constants/warehouse'
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Typography from "@mui/material/Typography";
import { numberFormat, numberFormatwithNeg } from "../../utils/numberFunctions";
import Div from "@jumbo/shared/Div";
import { CircularProgress } from '@mui/material';


const ProcurementDashboard = (props) => {
    var noWeeks = 4;
    const [startDate, setStartDate] = React.useState(shiftHours(startOfWeekMon(new Date()), -7 * 24));
    const [endDate, setEndDate] = React.useState(shiftHours(endOfWeekSun(new Date()), (noWeeks - 1) * 7 * 24));
    const startDateMemo = React.useMemo(() => (startDate), [startDate]);
    const endDateMemo = React.useMemo(() => (tomorrow(endDate)), [endDate]);
    const [location, setLocation] = React.useState(0);
    const [exReload, setExReload] = React.useState(false);
    const [reload, setReload] = React.useState(false);
    const [completed, setCompleted] = React.useState(false);
    const [supplier, setSupplier] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [inUse, setInUse] = React.useState(false);
    const [grades, setGrades] = React.useState([]);
    const [completedProcessRuns, setCompletedProcessRuns] = React.useState(null);
    let timer;
    const reloadFunc = () => {
        setReload(!reload);
    }
    React.useEffect(() => {
        getOysterGrades().then((data) => {
            setGrades(gradeSort(data));
        });
    }, []);
    React.useEffect(() => {
        const abortController = new AbortController();
        setLoading(true);
        setCompletedProcessRuns(null);
        if (supplier) {
            console.log(supplier)
            getAPIDataParamsReturn('/Processing/GetProcessRunsBySupplier', { supplierId: supplier ? supplier.supplierId : 0, startDate: textfieldDateFormat(startDate), endDate: textfieldDateFormat(endDate)},abortController).then(async (dataAll) => {
                var data = dataAll.filter((item) => !item.stockItem?.isProcessed);
                        console.log(data)
                for (var i = 0; i < data.length; i++) {
                    if (data[i].coreInventory.allReceivals.length > 0) {
                        //check the contents of allreceivals equal each other
                        var allReceivals = data[i].coreInventory.allReceivals; // remove duplicates
                        allReceivals = [...new Set(allReceivals)];
                        var missingReceivals = false;
                        for (var j = 0; j < allReceivals.length; j++) {
                            for (var k = j + 1; k < allReceivals.length; k++) {
                                if (allReceivals[j] !== allReceivals[k]) {
                                    missingReceivals = true;
                                }
                            }
                        }
                        if (missingReceivals) {
                            var recPrmArr = [];
                            for (var j = 0; j < allReceivals.length; j++) {
                                recPrmArr.push(getAPIDataReturn('/Receivals/Get/' + allReceivals[j],abortController))
                            }
                            await Promise.all(recPrmArr).then((values) => {

                                data[i].coreInventory.receivalsList = values;
                            })
                        }
                    }
                }
                setLoading(false);

                setCompletedProcessRuns(data);
            });
        }
        return () => {
            abortController.abort();
        };
    }, [supplier, startDate, endDate, reload]);


    const nextWeekfunc = () => {
        var newDates = shiftWeek(startDate, 1);
        setStartDate(newDates.start);
        setEndDate(newDates.end);
    }
    const lastWeekfunc = () => {
        var newDates = shiftWeek(startDate, -1);
        setStartDate(newDates.start);
        setEndDate(newDates.end);
    }
    const supplierFilter = (data) => {
        var newData = [...data];
        if (supplier) {
            newData = data.filter((item) => item.supplierId === supplier.supplierId);
        } else {
            return [];
        }
        var usedPRs = [];
        var sortedPRs = completedProcessRuns?completedProcessRuns.sort((a, b) => b.quantity - a.quantity):[];
        for (var i = 0; i < newData.length; i++) {
            var relevantPRs = sortedPRs.filter((item) => {
                if (item?.coreInventory?.receivalsList) {
                    if (item?.coreInventory?.receivalsList.find((rec) => rec?.purchaseOrderId == newData[i].id)) {
                        return true;
                    }
                } else {
                    return (item?.coreInventory?.receival?.purchaseOrderId == newData[i].id);
                }
            });
            var savedPRs = [];
            //organise daata because there can be two otrs for the same lsn and stock item
            for (var j = 0; j < newData[i].purchaseOrderLines.length; j++) {
                var quantityOfLine = newData[i].purchaseOrderLines[j].ordered;
                for (var k = 0; k < relevantPRs.length; k++) {
                    if (!(usedPRs.includes(relevantPRs[k].id))) {
                        if (relevantPRs[k].stockItemId === newData[i].purchaseOrderLines[j].stockItemId) {
                            if (relevantPRs[k].quantity <= quantityOfLine) {
                                quantityOfLine -= relevantPRs[k].quantity;
                                savedPRs.push(relevantPRs[k]);
                                usedPRs.push(relevantPRs[k].id);
                            }
                        }
                    }
                }
            }
            var unUsedPRs = relevantPRs.filter((item) => !usedPRs.includes(item.id));
            //group into grades
            var gradeTotals = {};
            for (var k = 0; k < savedPRs.length; k++) {
                var pr = savedPRs[k];
                if (!gradeTotals[pr.stockItem?.gradeId]) {
                    gradeTotals[pr.stockItem?.gradeId] = {};
                }
                for (var j = 0; j < pr.processRunOutputs.length; j++) {
                    var pro = pr.processRunOutputs[j];
                    // console.log(pro);
                    if (!gradeTotals[pr.stockItem?.gradeId][pro.stockItem?.gradeId]) {
                        gradeTotals[pr.stockItem?.gradeId][pro.stockItem?.gradeId] = 0;
                    }
                    gradeTotals[pr.stockItem?.gradeId][pro.stockItem?.gradeId] += (pro.quantity ? pro.quantity : 0);
                }
            }
            newData[i].processRuns = gradeTotals;
        }
        var cpyNewData = [...newData];
        var j = 0;
        var gradeTotals = {};
        for (var i = 0; i < cpyNewData.length; i++) {
            //insert a line into new data at the end of each week
            //sum all the grades for the week



            if (i === 0) {

            } else {
                if ((startOfWeekMon(undoDateFormat(cpyNewData[i].orderDate)) > startOfWeekMon(undoDateFormat(cpyNewData[i - 1].orderDate)))) {
                    var sumOfAllGradeTotals = 0;
                    for (var grade of grades) {
                        if (!gradeTotals[grade.abv]) {
                            gradeTotals[grade.abv] = 0;
                        }
                        sumOfAllGradeTotals += gradeTotals[grade.abv];
                    }

                    newData.splice(j, 0, { myobid: 'Week Total', orderDate: dateFormat(endOfWeekSun(undoDateFormat(cpyNewData[i - 1].orderDate))), comments: 'Sum Total', promisedDate: sumOfAllGradeTotals, ...gradeTotals });
                    j++;

                    gradeTotals = {};
                }
            }
            j++;
            for (var grade of grades) {
                if (!gradeTotals[grade.abv]) {
                    gradeTotals[grade.abv] = 0;
                }
                gradeTotals[grade.abv] += (cpyNewData[i][grade.abv] ? cpyNewData[i][grade.abv] : 0);
            }
            if (i === cpyNewData.length - 1) {
                var sumOfAllGradeTotals = 0;
                for (var grade of grades) {
                    if (!gradeTotals[grade.abv]) {
                        gradeTotals[grade.abv] = 0;
                    }
                    sumOfAllGradeTotals += gradeTotals[grade.abv];
                }
                newData.splice(j, 0, { myobid: 'Week Total', orderDate: dateFormat(endOfWeekSun(undoDateFormat(cpyNewData[i]?.orderDate))), comments: 'Sum Total', promisedDate: sumOfAllGradeTotals, ...gradeTotals });
                j++;

                gradeTotals = {};
            }
        }
        return newData;
    }

    return (<div>
        <Grid container spacing={2} mb={1} >
            <Grid item xs={6} sm={6} md={6} lg={6} xl={3}>
                <DateSelector montosun startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} noWeeks={noWeeks} />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
                {/* <WarehouseSelector location={location} setLocation={setLocation} />
                 */}
                <SelectFarmWarehouse showAll normal sortToTop setState={setSupplier} state={supplier} access={props.access} disabled={completed} title="Farm" />

            </Grid>
        </Grid>
        <Grid container spacing={3.5}>
            {/*<Grid item xs={12}>*/}
            {/*    <Summary oldInfo location={location} startDate={startDateMemo} endDate={(endDateMemo)} externalReload={exReload} />*/}
            {/*</Grid>*/}

            <Grid item xs={12}>
                <PurchaseOrders location={location} showQA oldInfo long totals height="3000px" nextWeek={nextWeekfunc} lastWeek={lastWeekfunc} filter={supplierFilter} warehouseFilter={Locations[location] ? Locations[location] : null} startDate={startDateMemo} endDate={(endDateMemo)} externalReload={exReload} shrinkTable reverseSort showOutcomes showWeekBrackets processRunsLoading={loading} exReloadFunc={reloadFunc} />
            </Grid>
            <Grid item xs={12}>
                <Typography variant={"h2"} >Processing Outcomes</Typography>
            </Grid>
            {!loading ? <Grid item xs={12}>
                <ProcessingSummaries processRuns={completedProcessRuns} grades={grades} />
            </Grid> : <CircularProgress />}
        </Grid>
    </div >);

};

const ProcessingSummaries = (props) => {
    const runs = props.processRuns || [];

    // Build quick lookup for grade metadata (not conditional)
    const gradeMap = React.useMemo(() => {
        const gm = {};
        props.grades?.forEach(g => gm[g.id] = g);
        return gm;
    }, [props.grades]);

    if (!runs.length) return null; // early return AFTER hooks

    // Group runs by mixedGroupId
    const groupedByMixed = {};
    runs.forEach(r => {
        if (r.mixedGroupId) {
            if (!groupedByMixed[r.mixedGroupId]) groupedByMixed[r.mixedGroupId] = [];
            groupedByMixed[r.mixedGroupId].push(r);
        }
    });

    const aggregatedRuns = [];
    const processedMixedIds = new Set();

    // Aggregate true mixed groups (more than one line sharing same id)
    Object.keys(groupedByMixed).forEach(mgId => {
        const arr = groupedByMixed[mgId];
        if (arr.length > 1) {
            processedMixedIds.add(mgId);
            let totalQty = 0;
            const comp = {}; // input composition by gradeId
            const outputs = {}; // aggregated outputs by gradeId
            arr.forEach(r => {
                const gId = r.stockItem?.gradeId;
                const qty = r.quantity || 0;
                totalQty += qty;
                comp[gId] = (comp[gId] || 0) + qty;
                r.processRunOutputs?.forEach(o => {
                    const og = o.stockItem?.gradeId;
                    if (!outputs[og]) outputs[og] = 0;
                    outputs[og] += (o.quantity || 0);
                });
            });
            // Build label e.g. "50% A, 50% B"
            const compParts = Object.keys(comp)
                .sort((a,b)=> (gradeMap[a]?.order||0) - (gradeMap[b]?.order||0))
                .map(gId => {
                    const pct = totalQty ? Math.round(comp[gId] / totalQty * 100) : 0;
                    const g = gradeMap[gId];
                    const labelPart = g ? (g.abv || (g.Species + ' ' + g.Grade)) : ('Grade ' + gId);
                    return `${pct}% ${labelPart}`;
                });
            const label = compParts.join(', ');
            aggregatedRuns.push({ key: 'mix:' + mgId, label, quantity: totalQty, outputs });
        }
    });

    // Add remaining (non-mixed or single-line groups)
    runs.forEach(r => {
        if (r.mixedGroupId && processedMixedIds.has(r.mixedGroupId)) return; // already aggregated
        const gId = r.stockItem?.gradeId;
        const g = gradeMap[gId] || {};
        const label = (g.Species ? (g.Species + ' ' + g.Grade) : ('Grade ' + gId));
        const outputs = {};
        r.processRunOutputs?.forEach(o => {
            const og = o.stockItem?.gradeId;
            if (!outputs[og]) outputs[og] = 0;
            outputs[og] += (o.quantity || 0);
        });
        aggregatedRuns.push({ key: 'single:' + (r.id || Math.random()), label, quantity: r.quantity || 0, outputs });
    });

    // Merge by label so identical compositions or single grades tally together
    const mergedByLabel = {};
    aggregatedRuns.forEach(ar => {
        if (!mergedByLabel[ar.label]) {
            mergedByLabel[ar.label] = { input: 0, output: {} };
        }
        mergedByLabel[ar.label].input += ar.quantity;
        Object.keys(ar.outputs).forEach(og => {
            if (!mergedByLabel[ar.label].output[og]) mergedByLabel[ar.label].output[og] = 0;
            mergedByLabel[ar.label].output[og] += ar.outputs[og];
        });
    });

    const orderedLabels = Object.keys(mergedByLabel).sort((a,b)=> mergedByLabel[b].input - mergedByLabel[a].input);

    return <Grid container spacing={3.5}>
        {orderedLabels.map(label => {
            const gt = mergedByLabel[label];
            if (gt.input > 0) {
                return <Grid key={label} item xs={12} sm={4} md={4} lg={4} xl={4} xxl={3}>
                    <StatCard title={label} value={gt.input} gradeTotal={gt.output} grades={props.grades} />
                </Grid>
            }
            return null;
        })}
    </Grid>
};



export default ProcurementDashboard;



const StatCard = (props) => {
    var bgroundStyle = {};
    if (props.color) {
        bgroundStyle = {
            background: props.color,
        }
    }
    var totalOut = 0;
    for (var key in props.gradeTotal) {
        totalOut += props.gradeTotal[key];
    }

    return <Card sx={{ position: "relative", ...bgroundStyle }} >
        <CardHeader
            title={<React.Fragment><Typography style={{}} variant={"h5"} mb={0}>{props.title} </Typography><Typography style={{ right: '10px', top: '15px', position: 'absolute' }} variant={"h2"}>{numberFormat(props.value)} doz</Typography></React.Fragment>}
            subheader={''}
            action={''}
            avatar={''}
            sx={{
                zIndex: 2,
                position: "relative",
                //...headerSx
            }}
        />
        <Div sx={{
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingBottom: '24px',
        }}>
            <Typography variant={"h6"} sx={{ textDecoration: 'underline' }}>Outputs</Typography>
            {props.grades.map((grade) => {
                if (props.gradeTotal[grade.id] > 0) {
                    return <Grid container spacing={3.5}>
                        <Grid item xs={7}>
                            <Typography  >{grade.Species + ' ' + grade.Grade}</Typography>
                        </Grid>
                        <Grid item xs={5} style={{textAlign: 'right'}}>
                            <Typography>{numberFormat(props.gradeTotal[grade.id]) + ' (' + (props.gradeTotal[grade.id] / totalOut * 100).toFixed(0) + '%)'}</Typography>
                        </Grid>
                    </Grid>
                } else {
                    return null;
                }
            })}
        </Div>
        <Div sx={{
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingBottom: '24px',
        }}>
            <Grid container spacing={3.5}>
            <Grid item xs={7}>
            <Typography variant={"h4"} sx={{}}>Total Out</Typography>
            <Typography variant={"h4"} sx={{}}>Variance</Typography>
            </Grid>
            <Grid item xs={5} style={{textAlign: 'right'}}>
            <Typography variant={"h4"} sx={{}}>{numberFormat(totalOut)} doz</Typography>
            <Typography variant={"h4"} sx={{}}>{numberFormatwithNeg(totalOut-props.value)} ({((totalOut-props.value)/props.value*100).toFixed(0)}%)</Typography>
            </Grid>
            </Grid>
            </Div>
    </Card>
}